import { Pipe, PipeTransform } from '@angular/core';
import { TrendingSeries, plotBandFeatures } from '../../trending-chart.helpers';

interface TrendingChartLegendPipeFormattedData {
  plotBandSeries: TrendingSeries[];
  regularSeries: TrendingSeries[];
}

@Pipe({
  name: 'trendingChartLegend',
  standalone: true,
})
export class TrendingChartLegendPipe implements PipeTransform {
  transform(input: TrendingSeries[]): TrendingChartLegendPipeFormattedData {
    const output: TrendingChartLegendPipeFormattedData = {
      plotBandSeries: [],
      regularSeries: [],
    };

    input.forEach((series) => {
      const seriesName = series.options?.id?.split('_')?.[1];
      if (!seriesName) {
        return;
      } else if (plotBandFeatures.some((bandFeature) => bandFeature === seriesName)) {
        output.plotBandSeries.push(series);
      } else {
        output.regularSeries.push(series);
      }
    });

    return output;
  }
}
